import type { AccessProfileId, UserAccessSnapshot } from '../contracts/types'

export const ACCESS_PROFILES: Record<AccessProfileId, UserAccessSnapshot> = {
  visitor: {
    accessState: 'visitor',
    accountReadiness: 'not_ready',
    serviceAccessMode: 'controlled',
    displayName: 'Creator (preview)',
  },
  creator_beta: {
    accessState: 'creator_beta',
    accountReadiness: 'ready_for_guided_studio',
    serviceAccessMode: 'controlled',
    displayName: 'Creator (preview)',
    lastActiveProjectId: 'orbis',
  },
}

export function resolveAccessProfile(
  profileId: string | null | undefined
): AccessProfileId {
  if (profileId === 'visitor') return 'visitor'
  if (profileId === 'revoked') return 'revoked'
  return 'creator_beta'
}
